const NavBarLoggedOutView = () => {
    return (
        <>
        </>
    );
}

export default NavBarLoggedOutView;